<h2 mat-dialog-title>Assign Vehicle ({{ data.plateNumber }})</h2>

<mat-dialog-content class="dialog-body">
  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Select Rider</mat-label>
    <mat-select [(value)]="selectedRiderId">
      <mat-option *ngFor="let r of riders" [value]="r.id">
        {{ r.fullName }} — {{ r.phoneNumber }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="close()" [disabled]="loading">Cancel</button>
  <button mat-flat-button color="primary" (click)="assign()" [disabled]="loading">Assign</button>
</mat-dialog-actions>
